const stepLabelKeys = {
  prepare_glb: 'importModels.steps.prepare_glb',
  glb_to_fbx: 'importModels.steps.glb_to_fbx',
  load_fbx: 'importModels.steps.load_fbx',
  normalize_materials: 'importModels.steps.normalize_materials',
  generate_artifacts: 'importModels.steps.generate_artifacts',
  render_screenshots: 'importModels.steps.render_screenshots',
  encode_textures: 'variantOptimization.steps.encode_textures',
  finalize: 'variantOptimization.steps.finalize',
};

export function getGlbJobStatusText(job, translate) {
  if (job?.status === 'queued') {
    return translate(
      ['filesystem_headroom', 'workspace_limit'].includes(job.waitReason)
        ? 'importModels.messages.converterWaitingForSpace'
        : 'importModels.messages.converterQueued',
    );
  }

  if (job?.status === 'failed') {
    return translate('importModels.errors.converterJobFailed');
  }

  if (job?.status === 'publish_unknown') {
    return translate('importModels.errors.converterPublishUnknown');
  }

  if (job?.status === 'done') {
    return translate('importModels.messages.converterCompleted');
  }

  if (job?.publish?.status === 'in_progress' || job?.step === 'publish') {
    return translate('importModels.messages.converterPublishing');
  }

  if (job?.status === 'running') {
    const stepKey = stepLabelKeys[job.step];

    return stepKey
      ? translate('importModels.messages.converterRunningStep', {
        step: translate(stepKey),
      })
      : translate('importModels.messages.converterRunning');
  }

  return translate('importModels.messages.converterCheckingStatus');
}

export function getGlbJobWaitDuration(job, now) {
  const createdAt = Date.parse(job?.createdAt);
  const startedAt = Date.parse(job?.startedAt);
  const end = Number.isFinite(startedAt)
    ? startedAt
    : job?.status === 'queued' ? now : NaN;

  if (!Number.isFinite(createdAt) || !Number.isFinite(end)) {
    return null;
  }

  const seconds = Math.max(0, Math.floor((end - createdAt) / 1000));

  return [
    Math.floor(seconds / 3600),
    Math.floor((seconds % 3600) / 60),
    seconds % 60,
  ].map((part) => String(part).padStart(2, '0')).join(':');
}
